import { render } from "./AlphabetList.vue?vue&type=template&id=38f24d5b&scoped=true"
import script from "./AlphabetList.vue?vue&type=script&lang=js"
export * from "./AlphabetList.vue?vue&type=script&lang=js"

import "./AlphabetList.vue?vue&type=style&index=0&id=38f24d5b&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f24d5b"]])

export default __exports__